import React, { useEffect, useState } from "react";
import { Navigate, useOutlet } from "react-router-dom";
import Sidebar from "./sidebar";
import Topbar from "../layouts/topbar";
import { CheckTokenExpire, GetAuthInPage } from "../components/utils/atuhen";
import {
  GetDataMenuData,
  GetDataRefreshToken,
  GetDataToken,
  SetDataRefreshToken,
  SetDataToken,
} from "../components/utils/data-storage";
import authenService from "../services/authenService";

const MasterPageAuth = () => {
  const outlet = useOutlet();
  const accessTokenData = GetDataToken();
  const refreshTokenData = GetDataRefreshToken();
  const menuData = GetDataMenuData();

  const GetRefreshToken = async (refreshToken) => {
    const rftData = await authenService.RefreshToken({
      refresh_token: refreshToken,
    });
    if (rftData !== undefined) {
      if (rftData.data.is_success === true) {
        SetDataToken(rftData.data.result.token.access_token);
        SetDataRefreshToken(rftData.data.result.token.refresh_token);
        return true;
      }
    }
    return false;
  };

  // ===== AUTH CHECK =====
  if (
    !accessTokenData ||
    !refreshTokenData ||
    !menuData
  ) {
    return <Navigate to="/login" replace />;
  } else {
    const accessTokenExpire = CheckTokenExpire(accessTokenData);
    if (accessTokenExpire === true) {
      const refreshTokenExpire = CheckTokenExpire(refreshTokenData);
      if (refreshTokenExpire === true) {
        return <Navigate to="/login" replace />;
      } else {
        const isRefreshToken = GetRefreshToken(refreshTokenData);
        if (isRefreshToken === false) {
          return <Navigate to="/login" replace />;
        }
      }
    }

    const authPage = GetAuthInPage();
    if (authPage === null) {
      return <Navigate to="/login" replace />;
    }
  }

  // ===== UI =====
  return (
    <div className="layout-wrapper">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div id="main">
        {/* Topbar */}
        <Topbar />

        {/* Page Content */}
        <div className="main-content">
          {outlet}
        </div>

        {/* Footer */}
        <div className="footer">
          © Digital Solutions
        </div>
      </div>
    </div>
  );
};

export default MasterPageAuth;